import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Tag, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import ChargingSessionDiagnostics from "@/components/OrderDetail/ChargingSessionDiagnostics";
import ClientChatStream from "@/components/OrderDetail/ClientChatStream";
import ClientContactCard from "@/components/OrderDetail/ClientContactCard";
import OrderParamsCard from "@/components/OrderDetail/OrderParamsCard";
import PayerCard from "@/components/OrderDetail/PayerCard";
import StatusHistoryTimeline from "@/components/OrderDetail/StatusHistoryTimeline";
import { getRootStore } from "@/stores/RootStore";
import { ROUTE_STATUS_LABELS, RouteStatus, } from "@/types/route/route.common";
import { B2B_ENABLED } from "@/utils/featureFlags";
import { getActiveRouteInfo } from "@/utils/orderRoute";
import styles from "@/styles/OrderDetail/DispatcherServiceSidebar.module.less";
const { Text } = Typography;
const ROUTE_STATUS_COLORS = {
    [RouteStatus.CREATED]: "default",
    [RouteStatus.PLANNED]: "blue",
    [RouteStatus.NOT_ACCEPTED]: "red",
    [RouteStatus.IN_PROGRESS]: "orange",
    [RouteStatus.COMPLETED]: "green",
    [RouteStatus.CANCELLED]: "red",
};
const formatDateTime = (iso) => {
    if (!iso)
        return "—";
    return new Date(iso).toLocaleString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};
const DispatcherServiceSidebar = observer(() => {
    const navigate = useNavigate();
    const { singleOrderStore } = getRootStore();
    // WP-DSP-FIX-03: любой маршрут, кроме CANCELLED (включая CREATED) — ссылка и статус
    const routeInfo = getActiveRouteInfo(singleOrderStore.order?.routeInfo);
    const handleRouteClick = (e) => {
        if (!routeInfo)
            return;
        e.preventDefault();
        if (e.metaKey || e.ctrlKey) {
            window.open(`/routes/${routeInfo.routeId}`, "_blank");
            return;
        }
        navigate(`/routes/${routeInfo.routeId}`);
    };
    return (_jsxs("div", { className: styles.sidebar, children: [_jsx(ClientContactCard, {}), B2B_ENABLED ? _jsx(PayerCard, {}) : null, _jsx(OrderParamsCard, {}), _jsx("div", { className: styles.routeBlock, children: routeInfo ? (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.routeLinkLabel, children: "\u041C\u0430\u0440\u0448\u0440\u0443\u0442" }), _jsxs("a", { className: styles.routeLink, href: `/routes/${routeInfo.routeId}`, onClick: handleRouteClick, children: [_jsx(Tag, { color: ROUTE_STATUS_COLORS[routeInfo.status], children: ROUTE_STATUS_LABELS[routeInfo.status] }), _jsxs(Text, { children: [routeInfo.routeId.slice(0, 8), "\u2026"] })] }), _jsxs("div", { className: styles.routeStartTime, children: ["\u0421\u0442\u0430\u0440\u0442: ", formatDateTime(routeInfo.plannedStartTime)] })] })) : (_jsx(Text, { className: styles.routeNoAssignment, children: "\u0417\u0430\u043A\u0430\u0437 \u043D\u0435 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D \u043D\u0430 \u043C\u0430\u0440\u0448\u0440\u0443\u0442" })) }), _jsx(StatusHistoryTimeline, {}), _jsx(ChargingSessionDiagnostics, {}), _jsx(ClientChatStream, {})] }));
});
DispatcherServiceSidebar.displayName = "DispatcherServiceSidebar";
export default DispatcherServiceSidebar;
